import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import App from 'App'
import { I18nProvider } from 'i18n'

import 'styles.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
      <Toaster position='top-right' />
    </I18nProvider>
  </React.StrictMode>
)
